import { useEffect, useState } from 'react';

/**
 * Henter git-avledet applikasjonsversjon fra /version.json (generert ved build av
 * generate-version.js). Rent additivt — uavhengig av useVersionCheck/usePublishedDate.
 * Returnerer tom streng hvis ikke tilgjengelig (f.eks. lokal dev uten version.json).
 */
export function useAppVersion(): string {
  const [version, setVersion] = useState<string>('');

  useEffect(() => {
    fetch('/version.json?t=' + Date.now())
      .then(res => (res.ok ? res.json() : null))
      .then(data => {
        if (data?.gitVersion) {
          setVersion(data.gitVersion);
        }
      })
      .catch(() => {
        // Ignorer — versjon er kun informativ
      });
  }, []);

  return version;
}
